<template>
  <div class="cricket-live" v-if="match && (match.now !== null)">
    <div class="collapse-btn ">
      <button v-if="isMetric" @click="collapseScoreBox = !collapseScoreBox" class="box">Collapse</button>
    </div>
    <div class="alerts">
      <div class="infoline alert-msg" v-if="match.now.break.reason">
        <span class="blink">⌁</span> {{match.now.break.reason | capitalise}}  break!
        <span v-if="match.now.break.duration">{{(match.now.break.duration)}}</span>
      </div>
      <div class="infoline" v-if="match.now.req && match.now.req.runs">
        <span class="info">&#9678;</span>
        <span class="highlight"> {{match.now.req.runs}}</span>
        <span v-if="match.now.req.balls">
          runs from
          <span class="highlight">{{match.now.req.balls}}</span>
          balls @
          <span>{{match.now.req.runs_rate}} RR</span>
        </span>
        <span v-else> required</span>
      </div>
    </div>

    <section class="fullwidth compact wrap-on-mobile reversed" v-if="!collapseScoreBox">
      <div class="part-first keep-left">
          <table class="full">
            <tbody>
              <cricket-match-scorecard-innings-bat-line
                v-for="playerKey in batsmanKeys"
                :key="playerKey"
                :match="match"
                :playerKey="playerKey"
                :inningsNumber="match.now.innings"
                :isShortView="true"
                @playerSelected="onPlayerSelected"
                @ballSelected="onBallSelected"></cricket-match-scorecard-innings-bat-line>
              <cricket-match-scorecard-innings-bowl-line
                v-for="playerKey in bowlerKeys"
                :key="playerKey"
                :match="match"
                :playerKey="playerKey"
                :inningsNumber="match.now.innings"
                :isShortView="true"
                @playerSelected="onPlayerSelected"></cricket-match-scorecard-innings-bowl-line>
            </tbody>
          </table>
        <div class="infoline last-ball" v-if="match.now.last_ball">
          <match-commentary-ball
          :ball="match.now.last_ball"
          @ballSelected="onBallSelected"
          ></match-commentary-ball>
        </div>
        <div class="infoline last-ball" v-if="match && match.now && match.now.bowling_end">
          <span v-for="playerKey in bowlerKeys" :key="playerKey">
            <span>{{match.players[playerKey].name}} bowling from 
              <span class="header-color">{{match.now.bowling_end}}</span>
            </span>
          </span>
        </div>
      </div>
      <div class="part-last">
        <div class="" v-if="match.now.batting_team">
          <div>
            <h5>
              <router-link v-if="match.teams && match.teams[match.now.batting_team] && match.teams[match.now.batting_team].match.season_team_key"
                class="clean"
                :to="{name:'cricketSeasonTeam', params:{
                  key:match.season.key, 
                  teamkey:match.teams[match.now.batting_team].match.season_team_key}}">
                {{match.teams[match.now.batting_team].name}}</router-link>
            </h5>
          </div>
          <div>
            <span class="highlight main">{{match.now.runs}}/{{match.now.wicket}}</span>
            <span class="main" v-if="match.innings && match.innings[match.now.batting_team]"> ({{match.innings[match.now.batting_team + '_' + match.now.innings].overs}})</span>
          </div>
          <div>{{match.now.run_rate}} RR</div>
        </div>

        <div class="infoline next-ball" v-if="match.now.next_ball && match.now.next_ball.over_str">
          <span>➟ </span>
          <span v-if="match.now.next_ball.bowler">
            <span class="clickable link-color" @click="onPlayerSelected(match.now.next_ball.bowler)">
              {{match.players[match.now.next_ball.bowler].name}}
            </span>
            will bowl {{match.now.next_ball.over_str}}
            <span v-if="match.now.next_ball.striker">
              to 
              <span class="clickable link-color" @click="onPlayerSelected(match.now.next_ball.striker)">
                {{match.players[match.now.next_ball.striker].name}}
              </span>
            </span>
          </span>
          <span v-else-if="match.now.next_ball.striker">
            <span class="clickable link-color" @click="onPlayerSelected(match.now.next_ball.striker)">
              {{match.players[match.now.next_ball.striker].name}}
            </span>
            will bat for {{match.now.next_ball.over_str}}
          </span>
          <span v-else>
            Waiting for bowler and batsman for {{match.now.next_ball.over_str}}
          </span>
        </div>
        <div class="infoline silent" v-if="match.now.req && match.now.req.target_runs">
            Target:
            <span>{{match.now.req.target_runs}}</span>
            <span v-if="match.now.req.target_balls">(<span>{{match.now.req.target_balls}}</span> b)</span>
        </div>

        <div class="infoline alert" v-if="match.now.lead_by_str || match.now.trail_by_str">
          <div v-if="match.now.lead_by_str">{{match.now.lead_by_str}}</div>
          <div v-if="match.now.trail_by_str">{{match.now.trail_by_str}}</div>
        </div>

      </div>
    </section>


    <div class="recent-balls" v-if="match.now.recent_overs && match.now.recent_overs.length > 0">
      <span
        v-for="overBalls in match.now.recent_overs"
        :key="overBalls[0]">
        <span
          v-for="ballKey in overBalls[1]"
          :key="ballKey">
          <match-ball-icon
            :ball="match.balls[ballKey]"
            @ballSelected="onBallSelected"
          ></match-ball-icon>
        </span>
        |
      </span>
    </div>
  </div>
</template>
<script>
import MatchCommentaryBall from '@/components/cricket/MatchCommentaryBall.vue'
import MatchBallIcon from '@/components/cricket/MatchBallIcon.vue'

export default {
  components: {
    'MatchCommentaryBall': MatchCommentaryBall,
    'MatchBallIcon': MatchBallIcon
  },
  props: {
    match: Object,
    matchUserPref: Object,
    isMetric : {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      collapseScoreBox: false
    }
  },
  computed: {
    batsmanKeys () {
      let keys = []
      if (this.match.now.striker) {
        keys.push(this.match.now.striker)
      }
      if (this.match.now.nonstriker) {
        keys.push(this.match.now.nonstriker)
      }
      return keys
    },

    bowlerKeys () {
      let keys = []
      if (this.match.now.bowler) {
        keys.push(this.match.now.bowler)
      }
      return keys
    }
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
